import { lazy } from 'react';

export const OutCorAddLazy = lazy(() => import('./OutCorAdd'));
